/* eslint-disable security/detect-object-injection */
import { boostBuildPreferences } from './boostBuildPreferences';

export function boostBodyType(bodyTypes, rankedBodyTypes) {
  for (let i = 0; i < bodyTypes?.length; i += 1) {
    boostBuildPreferences(rankedBodyTypes, bodyTypes[i]);
  }
}
